import classNames from 'classnames';
import { ReactComponent as UploadIcon } from '../img/iconUpload.svg';
import { FC } from 'react';
import { useGetOrderUploadTemplateMutation } from '../../../redux/Api/ordersApi/ordersApi';
import { getFileNameFromContentDisposition } from '../../../utils/strActions';
import styles from './TemplateLink.module.scss';

interface TemplateLinkProps {
  hasFile: boolean;
}

export const TemplateLink: FC<TemplateLinkProps> = ({ hasFile }) => {
  const [getTemplate] = useGetOrderUploadTemplateMutation();

  const handleDownloadTemplate = async () => {
    try {
      const result = await getTemplate();

      if ('data' in result && result.data) {
        const { blob, headers } = result.data;
        const disposition = headers.get('content-disposition');
        const filename =
          getFileNameFromContentDisposition(disposition) || 'orders-upload-template.xlsx';

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Ошибка получения шаблона');
      }
    } catch (error) {
      console.error('Ошибка скачивания шаблона:', error);
    }
  };

  return (
    <button
      className={classNames(styles.link, styles.template)}
      style={!hasFile ? { marginBottom: '4px' } : {}}
      onClick={handleDownloadTemplate}
      type='button'>
      Шаблон реестра заданий <UploadIcon />
    </button>
  );
};
